import { I18NText, Position, State, StateObj, WebPartsObj } from 'src/types'
import { usModelOfAtomsChecker } from 'src/logic'
import { webPartsPositionFilter } from 'src/logic'
import { APL_UR002_PLUS_PRODUCT_NUMBER } from '../../japan/constants/baseModel'

export const fingerGuardTypeObjectSwitcher = (isOutfielder: boolean, t: I18NText): StateObj[] => {
  return isOutfielder ? t.FINGER_GUARD_TYPE_FOR_OUTFIELDER_OBJECTS : t.FINGER_GUARD_TYPE_OBJECTS
}

export const atomsFlagGenerator = (state: State, position: Position) => {
  const isCatcher = position === 'catcher'
  const isDefaultSize = state.size.value === 'default'
  const isLeftThrow = state.dominantArm.value === 'leftThrow'
  const isTannerSelected = state.tanner?.value !== 'unselected'
  const isCatcherAndOtherThanAplSeries = isCatcher && state.baseModel.productNumber !== APL_UR002_PLUS_PRODUCT_NUMBER
  const isUsModel = usModelOfAtomsChecker(state.baseModel.productNumber)
  const isMoldingOrder = state?.moldingOrder?.value !== 'none'
  return {
    isCatcher,
    isDefaultSize,
    isLeftThrow,
    isTannerSelected,
    isCatcherAndOtherThanAplSeries,
    isUsModel,
    isMoldingOrder
  }
}

export const baseCautionGenerator = (partsKey: string, t: I18NText): string => {
  switch (partsKey) {
    case 'tanner':
      return t.CAUTION_TANNER
    case 'dominantArm':
      return t.CAUTION_DOMINANT_ARM
    case 'size':
      return t.CAUTION_SIZE
    case 'moldingOrder':
      return t.CAUTION_MOLDING_ORDER
  }
}

export const webPartsFilter = (productNumber: string, position: Position, webParts: WebPartsObj[]) => {
  const isYouthModel = ['AGL-1001', 'AGL-1004', 'AGL-1006'].includes(productNumber)
  return isYouthModel ? webParts.filter((w) => w.isYouth) : webPartsPositionFilter(webParts, position)
}
